export default __webpack_public_path__ + "static/kitten-f3cd22620499732005c4480db91e8dbe.jpg";